import type { Icon } from 'types';

type Props = { fill: string } & Icon;

export default function TikTokIcon({ fill, height, width }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill}
        d="M19.2 10.84V8C17.87 8 16.855 7.645 16.2 6.955C15.5277 6.16752 15.1511 5.17027 15.135 4.135V3.93L12.45 3.865C12.45 3.865 12.45 3.98 12.45 4.135V15.4C12.3579 15.9033 12.1136 16.3662 11.7501 16.7262C11.3865 17.0863 10.9213 17.3261 10.4172 17.4133C9.91302 17.5006 9.39425 17.4311 8.93087 17.2141C8.4675 16.9972 8.08184 16.6433 7.82596 16.2003C7.57007 15.7572 7.45629 15.2463 7.49997 14.7365C7.54364 14.2268 7.74268 13.7427 8.0702 13.3496C8.39772 12.9565 8.83796 12.6734 9.33148 12.5385C9.825 12.4035 10.348 12.4233 10.83 12.595V9.845C10.549 9.79896 10.2647 9.77555 9.98 9.775C8.95549 9.775 7.95399 10.0788 7.10215 10.648C6.2503 11.2172 5.58637 12.0262 5.1943 12.9727C4.80224 13.9192 4.69966 14.9607 4.89953 15.9656C5.0994 16.9704 5.59275 17.8934 6.31719 18.6178C7.04162 19.3422 7.96461 19.8356 8.96943 20.0355C9.97425 20.2353 11.0158 20.1328 11.9623 19.7407C12.9088 19.3486 13.7178 18.6847 14.287 17.8329C14.8562 16.981 15.16 15.9795 15.16 14.955C15.1594 14.7427 15.1461 14.5307 15.12 14.32V9.745C16.3409 10.5075 17.7614 10.8887 19.2 10.84V10.84Z"
      />
    </svg>
  );
}
